/* ==========================================================================
   Naar Halı — header küçük betiği (22 Eki 2026'da yeniden yazıldı)

   1) Arama simgesi (1024 px altı).
      Eskiden telefonda header iki satırdı (logo + arama çubuğu) ve hep yapışıktı; 812 px'lik
      ekranın 141 px'ini sürekli kapatıyordu. 5 Eki 2026'da arama satırı aşağı kaydırırken
      clip-path ile gizleniyordu. Şimdi çubuk baştan gizli, header tek satır (~65 px);
      sağdaki arama simgesine dokunulunca çubuk açılır ve kutuya odaklanılır.
      Kapanma: simgeye ikinci dokunuş, Esc, kutu boşken başka yere dokunuş, menü çekmecesinin
      açılması ya da pencerenin masaüstü genişliğine gelmesi. Kutuda yazı varsa başka yere
      dokununca açık kalır (yazı kaybolmasın).
      Masaüstünde (>=1024 px) hiçbir şey yapmaz; orada çubuk hep görünür.

   2) Menüdeki "Kasım İndirimleri" bağlantısı (snippets/naar-menu-kasim.liquid).
      Ana sayfadaysak sayfa yenilenmeden vitrine kayar (telefon menüsü açıksa önce kapanır,
      çünkü çekmece açıkken sayfa kaydırması kilitli). Başka sayfadaysak bağlantı normal
      çalışır ve ana sayfada vitrine iner.
   ========================================================================== */
(function () {
  var sinif = 'naar-arama-acik';
  var govde = document.body;
  var dar = window.matchMedia('(max-width: 1023.98px)');
  var azHareket = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- 1) Arama simgesi ---------- */
  var dugme = document.querySelector('.naar-arama-ac');
  var cubuk = document.querySelector('.header__search');
  var kutu = cubuk && cubuk.querySelector('input[type="search"]');

  function acik() { return govde.classList.contains(sinif); }

  function ac() {
    if (!dar.matches || !cubuk) return;
    govde.classList.add(sinif);
    if (dugme) dugme.setAttribute('aria-expanded', 'true');
    // Odak, dokunma olayının içinde verilmeli (iOS klavyeyi yalnızca böyle açar).
    if (kutu) kutu.focus();
  }

  function kapat() {
    if (!acik()) return;
    govde.classList.remove(sinif);
    if (dugme) dugme.setAttribute('aria-expanded', 'false');
    if (kutu && cubuk.contains(document.activeElement)) kutu.blur();
  }

  if (dugme && cubuk) {
    dugme.addEventListener('click', function () {
      if (acik()) kapat();
      else ac();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !acik()) return;
      kapat();
      dugme.focus();
    });

    // Kutu boşken başka yere dokunulursa kapanır
    document.addEventListener(
      'pointerdown',
      function (e) {
        if (!acik() || !dar.matches) return;
        if (cubuk.contains(e.target) || dugme.contains(e.target)) return;
        if (kutu && kutu.value.trim() !== '') return;
        kapat();
      },
      true
    );

    // Menü çekmecesi açılınca arama kapanır (ikisi birden ekranı doldurmasın)
    document.addEventListener('menu-drawer:open', kapat);

    var genislik = function () { if (!dar.matches) kapat(); };
    if (dar.addEventListener) dar.addEventListener('change', genislik);
    else if (dar.addListener) dar.addListener(genislik);
  }

  /* ---------- 2) Kasım İndirimleri bağlantısı ---------- */
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a.naar-menu-kasim');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (x) { return; }
      if (!url.hash || url.pathname !== window.location.pathname) return; // başka sayfa: normal gezinme
      var hedef = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!hedef) return;
      e.preventDefault();

      var cekmece = a.closest('menu-drawer');
      var bekle = 0;
      if (cekmece && typeof cekmece.hide === 'function') {
        cekmece.hide();
        bekle = 420; // çekmece kapanıp sayfa kaydırma kilidi kalkana kadar
      }
      window.setTimeout(function () {
        hedef.scrollIntoView({ behavior: azHareket.matches ? 'auto' : 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', url.hash);
      }, bekle);
    },
    true
  );
})();

/* ==========================================================================
   3) Ana sayfada şeffaf → blurlu → beyaz header (24 Eki 2026)

   <html data-naar-hdr> yalnızca ana sayfada ve sections/header.liquid'deki erken betikle konur. Durumlar:
     seffaf  sayfa tepesinde (kaydırma <= 6 px)
     blur    biraz kaydırınca, banner hâlâ header'ın arkasındayken
     beyaz   banner header'ın arkasından çıkınca; ayrıca menü / arama / çekmece açıkken ve kaydırılmışken fare ya da klavye odağı header'dayken
   Görünüm assets/naar-duzeltmeler.css'te. Betik yalnızca durumu değiştirir (kaydırma olayı, kare başına en çok bir kez).
   ========================================================================== */
(function () {
  var kok = document.documentElement;
  if (!kok.hasAttribute('data-naar-hdr')) return;
  var baslik = document.querySelector('header.header');
  if (!baslik) return;
  var hero = document.querySelector('.naar-hero-seffaf');
  if (!hero) {
    // Bu sayfada header'ın altına binecek banner yok (bölüm kaldırılmış / ayar kapalı): header olduğu gibi beyaz kalsın
    kok.removeAttribute('data-naar-hdr');
    kok.style.removeProperty('--naar-hdr-h');
    return;
  }
  var ustSatir = baslik.querySelector('.header__top');
  var dokunmatik = window.matchMedia('(hover: none)').matches;
  var uzerinde = false;
  var bekliyor = false;

  function menuAcik() {
    var b = document.body.classList;
    if (b.contains('has-dropdown-menu') || b.contains('search-open') || b.contains('naar-arama-acik') || b.contains('predictive-search-open')) return true;
    var cekmece = document.querySelector('menu-drawer');
    return !!(cekmece && !cekmece.hasAttribute('hidden'));
  }

  function hesapla() {
    bekliyor = false;
    var y = window.scrollY || 0;
    var yeni;
    // Sayfanın en üstünde fare/odak header'a gelse de şeffaf kalır; yalnızca menü/arama/çekmece açılınca beyaz olur
    if (menuAcik() || (uzerinde && !dokunmatik && y > 6)) {
      yeni = 'beyaz';
    } else if (y <= 6) {
      yeni = 'seffaf';
    } else {
      // Header'ın görünen alt kenarı: menü satırı kapalıyken yalnızca üst satır
      var altSinir = document.body.classList.contains('is-hide-nav') && ustSatir ? ustSatir.getBoundingClientRect().bottom : baslik.getBoundingClientRect().bottom;
      var heroAlt = hero ? hero.getBoundingClientRect().bottom : 480 - y;
      yeni = heroAlt > altSinir + 2 ? 'blur' : 'beyaz';
    }
    if (kok.getAttribute('data-naar-hdr') !== yeni) kok.setAttribute('data-naar-hdr', yeni);
  }
  function planla() {
    if (bekliyor) return;
    bekliyor = true;
    window.requestAnimationFrame(hesapla);
  }

  window.addEventListener('scroll', planla, { passive: true });
  window.addEventListener('pageshow', planla);
  baslik.addEventListener('mouseenter', function () { uzerinde = true; planla(); });
  baslik.addEventListener('mouseleave', function () { uzerinde = false; planla(); });
  baslik.addEventListener('focusin', function () { uzerinde = true; planla(); });
  baslik.addEventListener('focusout', function (e) { if (!baslik.contains(e.relatedTarget)) { uzerinde = false; planla(); } });
  if ('MutationObserver' in window) {
    new MutationObserver(planla).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var cekmece = document.querySelector('menu-drawer');
    if (cekmece) new MutationObserver(planla).observe(cekmece, { attributes: true, attributeFilter: ['hidden', 'open', 'class'] });
  }

  // Header yüksekliği (ekran genişliği değişince menü satırı kırılabilir): banner boşluğu güncel kalsın
  var oncekiGenislik = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === oncekiGenislik) return;
    oncekiGenislik = window.innerWidth;
    if (document.body.classList.contains('naar-arama-acik')) return;
    kok.style.setProperty('--naar-hdr-h', baslik.offsetHeight + 'px');
    planla();
  }, { passive: true });

  hesapla();
})();
